import React, { useContext, useEffect } from 'react'
import { HandbagIcon, HeartIcon, UserIcon } from '@phosphor-icons/react'
import SoftButton from '@components/common/SoftButton'
import LinkButton from "@components/common/LinkButton"
import { useIsTablet } from '@components/helpers/useWindowSize'
import { StoreContext } from "@context/StoreContext"
import UserContext from '@context/UserContext'
import { sendGAEvent } from '@utils/analytics'
import { GA_EVENTS } from '@utils/analytics/constants'
import SearchButton from './SearchButton'
import UserAccountMenu from './UserAccountMenu'
import CurrencySelector from '../CurrencySelector'

const IconMenu = ({ searhBarOptions, handleSearchBar }) => {
	const isTablet = useIsTablet()
	const { onOpen, isOpen, checkout } = useContext(StoreContext)
	const { isLoggedIn, setOpenLoginModal } = useContext(UserContext)

	useEffect(() => {
		// console.info("bag contents:",checkout)
		const cartItems = checkout?.lines?.edges?.map(item => {
			const { merchandise } = item?.node
			return {
				id: merchandise?.id,
				price: merchandise?.price?.amount,
				currency: merchandise?.price?.currencyCode,
				title: merchandise?.product?.title,
				size: merchandise?.title,
			}
		})
		if (isOpen) sendGAEvent(GA_EVENTS.BAG_VIEW, { queryName: "bag viewed", items: [...cartItems] })
	}, [isOpen])

	return (
		<React.Fragment>
			<div className="relative flex gap-x-6 text-black text-sm mx-4 md:mr-2">
				<div className="flex justify-between items-center max-w-[1440px] mx-auto flex-1 gap-x-4">
					{ (process.env.GATSBY_STORE !== "PH" && isTablet) && <CurrencySelector /> }
					<div className='flex-1'>
						<SearchButton 
							className={searhBarOptions && searhBarOptions?.className}
							onClick={() => { handleSearchBar() }} 
							showInputField={searhBarOptions && searhBarOptions?.showInputField}
						/>
					</div>
					<LinkButton
						ariaLabel="Favorite"
						label={<HeartIcon className="menu-icons" weight="light" />}
						to={`${isLoggedIn ? '/user-account/wishlist' : '/wishlist'}`}
					/>
					<SoftButton 
						ariaLabel="Cart" 
						label={<HandbagIcon className='menu-icons' weight="light" />} 
						onClick={() => onOpen()} 
					/>
					{!isLoggedIn ? (
						<SoftButton 
							ariaLabel="Profile" 
							label={<UserIcon className='menu-icons' weight="light" />} 
							onClick={() => setOpenLoginModal(true)} 
						/>
					) : (
						<UserAccountMenu />
					)}
				</div>
			</div>
		</React.Fragment>
	)
}

export default IconMenu